import { conversationsGateway } from "@/gateways/conversationsGateway";
import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import type { Conversation } from "./types";

export function useGetContactConversations(contactId: string) {
  const query = useQuery({
    initialData: [],
    queryKey: ["contactConversations", contactId],
    queryFn: () => conversationsGateway.listConversationsByContactId(contactId),
  });

  return {
    ...query,
    getContactConversationsStatus: query.status,
    conversations: query.data,
  };
}

export function useUpdateContactConversation(contactId: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (conversation: Conversation) =>
      conversationsGateway.updateConversation(conversation),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["contactConversations", contactId],
      });
    },
  });

  return {
    ...mutation,
    updateContactConversationStatus: mutation.status,
    updateConversation: mutation.mutate,
  };
}

export function useDeleteContactConversation(contactId: string) {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (conversation: Conversation) =>
      conversationsGateway.deleteConversation(conversation.id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["contactConversations", contactId],
      });
    },
  });

  return {
    ...mutation,
    resetDeleteContactConversation: mutation.reset,
    deleteContactConversationStatus: mutation.status,
    deleteConversation: mutation.mutate,
  };
}
